import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      boxShadow: 'none',
      padding: theme.spacing(1),
      background: theme.palette.task.development,
      borderRadius: 0,
      [theme.breakpoints.up('md')]: {
        borderRadius: 12,
      },
    },
    content: {
      background: theme.palette.background.paper,
      borderRadius: 12,
      padding: theme.spacing(1),
    },
    dueDate: {
      paddingTop: theme.spacing(1),
    },
    title: {
      fontWeight: 700,
      fontSize: 18,
      lineHeight: '23px',
      letterSpacing: '0.16px',
    },
    header: {
      padding: theme.spacing(0.5, 3, 1.5),
      display: 'flex',
      justifyContent: 'space-between',
      color: '#19181F',
    },
    value: {
      fontWeight: 500,
      fontSize: 32,
      lineHeight: '40px',
      letterSpacing: '0.16px',
    },
    label: {
      fontWeight: 700,
      fontSize: 20,
      lineHeight: '25px',
      letterSpacing: '0.114286px',
      color: '#AFA8DE',
      marginRight: 2,
    },
    taxTypeLabel: {
      fontWeight: 700,
      color: '#AFA8DE',
    },
    helpIcon: {
      fontSize: '1em',
      transform: 'translateY(0.25em)',
    },
    blured: {
      [theme.breakpoints.up('md')]: {
        filter: 'blur(10px)',
      },
    },
  }),
);

export default useStyles;
